import axios from "utils/http";

/**
 * 消息通知
 * @param {*} data 
 * @returns 
 */

// 通知列表
export function getData (data) {
    return axios.get("/admin/notification", { params: data }).then(res => {
        return Promise.resolve(res);
    });
}

// 通知详情
export function getDetail (data) {
    return axios.get(`/admin/notification/${data.id}`, { params: data }).then(res => {
        return Promise.resolve(res);
    });
}

// 是否全部改为已读或未读
export function read (data) {
    return axios.post(`/admin/notification`, data).then(res => {
        return Promise.resolve(res);
    });
}

// edit
export function getEdit (id) {
    return axios.get(`/admin/notification/${id}`).then(res => {
        return Promise.resolve(res);
    });
}

// delete
export function deleteItem (id) {
    return axios.delete(`/admin/notification/${id}`).then(res => {
        return Promise.resolve(res);
    });
}


// WEBPACK FOOTER //
// ./src/api/message.js